<template>
    <div>
        <!-- <NavBack title="Loan Confirmation"></NavBack> -->
        <tool-bar title="Loan Confirmation"></tool-bar>

        <div class="product">
            <div class="product-card">
                <div class="product-card-title">Loan amount</div>
                <div class="product-card-list">
                    <div class="product-card-list-item" :class="{ 'product-card-list-item-active': chooseMoney == i }"
                        @click="changeMoney(i)" v-for="(i, index) of money" :key="index">
                        <span class="money">₦ {{ $thousands(i) }}</span>
                    </div>
                </div>
                <div v-if="chooseMoney" class="product-card-title">Loan term</div>
                <div v-if="chooseMoney" class="product-card-list">
                    <div class="product-card-list-item" :class="{ 'product-card-list-item-active': chooseDay == i }"
                        @click="changeDay(i)" v-for="(i, index) of day" :key="index">
                        <div class="day">{{ i }}</div>
                        <div class="unit">day</div>
                    </div>
                </div>
            </div>
            <div v-if="productDetail">
                <div class="product-detail">
                    <div class="product-detail-title">Loan details</div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Loan amount</span> </div>
                        <div>
                            <!-- 贷款额度 -->
                            ₦{{ $thousands(productDetail.amount) }}
                        </div>
                    </div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label">
                            <span>Passion - </span>
                            <span class="product-detail-row-label-sub">(prepaid)</span>
                        </div>
                        <div>
                            <!-- 利息 --> ₦{{ $thousands(productDetail.interestAmount) }}
                        </div>
                    </div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label">
                            <span>Audit fee - </span>
                            <span class="product-detail-row-label-sub">(prepaid)</span>
                        </div>
                        <div>
                            <!-- 审计费 -->
                            ₦{{ $thousands(productDetail.auditServiceFee) }}
                        </div>
                    </div>
                    <!-- <div class="product-detail-row">
                    <div class="product-detail-row-label"> <span>VAT</span> </div>
                    <div>₦ 6500</div>
                </div> -->
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Expiration date</span> </div>
                        <div>
                            <!-- 应还款时间 -->
                            {{ $dayjs(productDetail.estimateDueDate).format("DD-MM-YYYY") }}
                        </div>
                    </div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Accepted Quantity</span> </div>
                        <div class="green">
                            <!-- 到手金额 -->₦{{ $thousands(productDetail.receivedAmount) }}
                        </div>
                    </div>
                </div>
                <div class="product-detail">
                    <div class="product-detail-title">Maturity and debt</div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Service fee </span> </div>
                        <!-- 后置服务费 -->
                        <div>₦{{ $thousands(productDetail.afterAuditServiceFee) }}</div>
                    </div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Maturity and debt </span> </div>
                        <div class="green">₦{{ $thousands(productDetail.repaymentAmount) }}</div>
                    </div>
                </div>
                <div v-if="userInfo" class="product-detail">
                    <div class="product-detail-title">Withdrawal information</div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Bank name</span> </div>
                        <div>{{ userInfo.bank }}</div>
                    </div>
                    <div class="product-detail-row">
                        <div class="product-detail-row-label"> <span>Receive account</span> </div>
                        <div class="green">**** {{ userInfo.accountNo ? userInfo.accountNo.slice(-4) : '' }}</div>
                    </div>
                </div>
            </div>

            <div class="product-footer">
                <van-button class="primary-btn" :disabled="!productDetail" block @click="toLoan">Confirm
                    application
                </van-button>
            </div>
        </div>
    </div>

</template>

<script>
import { analyzeLoan, calculateFees, apply } from '@/api/loan';
import { load } from '@/api/user'
export default {
    data() {
        return {
            productDetail: '',
            userInfo: {},
            product: [],
            money: [],
            chooseMoney: '',
            day: [],
            chooseDay: '',
            chooseProduct: '',
        }
    },
    mounted() {
        this.getProduct()
        this.getBank()
    },
    watch: {
        chooseDay() {
            const tem = this.product.find(i => i.period == this.chooseDay && i.amount == this.chooseMoney)
            if (tem) { this.getProductDetail(tem) }
            this.chooseProduct = tem || ''
        }
    },
    methods: {
        async getBank() {
            this.userInfo = await load()
        },
        async getProduct() {
            const res = await analyzeLoan()
            this.product = res
            this.handleProduct()
        },
        handleProduct() {
            this.product.forEach(i => {
                if (!this.money.includes(i.amount)) {
                    this.money.push(i.amount)
                }
                if (!this.day.includes(i.period)) {
                    this.day.push(i.period)
                }
            });
        },
        changeMoney(amount) {
            this.chooseMoney = amount
            this.chooseDay = ''
            this.day = []
            this.productDetail = null
            this.product.forEach(i => {
                if (i.amount == amount) {
                    this.day.push(i.period)
                }
            });
        },
        changeDay(period) {
            this.chooseDay = period
        },
        async getProductDetail(tem) {
            this.productDetail = await calculateFees({ rateId: tem.id })
        },
        async toLoan() {
            const res = await apply({ loanRateId: this.chooseProduct.id })
            console.log(res)
            if (res) {
                this.$router.push('/home')
            }
        }
    },
}
</script>

<style lang="less" scoped>
.product {
    padding: 15px 10px 90px;
    height: calc(100vh - 70px);
    box-sizing: border-box;
    overflow-y: scroll;
    background-color: @Main-bg;

    &-card {
        padding: 24px 15px;
        font-weight: bold;
        border-radius: 15px;
        background-color: #fff;

        &-title {
            font-size: 16px;

        }

        &-list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 0 30px;

            &:last-child {
                margin: 0;
            }

            &-item {
                margin: 10px 10px 0 0;
                padding: 15px;
                color: #212750;
                text-align: center;
                background-color: @Main-bg;
                border-radius: 12px;

                &:last-child {
                    margin: 10px 0 0;
                }

                .money {
                    font-size: 27px;
                }

                .day {
                    font-size: 25px;
                }

                .unit {
                    margin: 8px 0 0;
                    font-size: 15px;
                }
            }

            &-item-active {
                color: #fff;
                background: linear-gradient(to right, @MainColor, @SecondaryColor);

                .money {
                    font-size: 30px;
                }

                .day {
                    font-size: 30px;
                }
            }
        }
    }

    &-detail {
        margin: 15px 0;
        padding: 27px 15px;
        font-weight: bold;
        border-radius: 15px;
        background-color: #fff;

        &-title {
            margin: 0 0 20px;
            color: #212750;
            font-size: 19px;
        }

        &-row {
            margin: 0 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 18px;

            &-label {
                font-size: 16px;
                color: rgba(33, 39, 80, .7);

                &-sub {
                    color: #81939B;
                }
            }

            .green {
                color: @MainColor;
                font-size: 24px;
            }

            &:last-child {
                margin: 0;
            }
        }
    }

    &-footer {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 7.5px 9px;
        background-color: #fff;
    }

    .primary-btn {
        min-width: 125px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: #fff;
        font-size: 19px;
        font-weight: bold;
        border-radius: 8px;
        background: linear-gradient(to left, @SecondaryColor, @MainColor);
    }

}
</style>